module.exports = __webpack_public_path__ + "img/view-two-pane.16b667eb.svg";